/**
 * This is a helper file to allow callers to do
 *      import {} from 'capi/redux/immutable'
 * instead of digging through the /lib dir or
 * adding redux-immutable-specific exports
 * (and therefore the redux and immutable requirements)
 * to the root index.js
 */
module.exports = require('../lib/redux/immutable');
